import { Box, Typography, Paper, Card, CardContent } from "@mui/material";

export const TypographyUsageExamples = () => {
  return (
    <>
      <Box mb={2}>
        <Typography>Example usage of a page header and description:</Typography>
      </Box>
      <Paper
        elevation={2}
        sx={{
          p: 3,
          mb: 6,
          borderLeft: "4px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h1" gutterBottom>
          Example Header
        </Typography>
        <Typography variant="body2" color="text.secondary">
          An example of a description that describes what the contents of this page.
        </Typography>
      </Paper>

      <Paper elevation={1} sx={{ p: 3, mb: 6, border: "1px dashed", borderColor: "divider" }}>
        <Typography variant="h3" gutterBottom>
          Spacing Guidelines Example
        </Typography>
        <Box sx={{ mb: 3 }}>
          <Card>
            <CardContent>
              <Typography variant="h4">Card Title</Typography>
              <Typography variant="body2" color="text.secondary">
                Card description or helper content goes here.
              </Typography>
            </CardContent>
          </Card>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h4">Another Section</Typography>
        </Box>
        <Box>
          <Typography variant="body1">Some paragraph content here using consistent 8px vertical spacing.</Typography>
        </Box>
      </Paper>
    </>
  );
};
